export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
export const ANALYTICS_VERSION = "v1";

let initialized = false;

const TOPIC_KEYWORDS = {
  revenue: ["revenue", "royalty", "royalties", "tax", "fiscal", "income", "payment"],
  production: ["production", "output", "barrel", "crude", "gas", "flaring", "reserve"],
  licensing: ["license", "licence", "contract", "bid", "block", "award", "marginal field"],
  environment: ["environment", "pollution", "spill", "flare", "emission", "climate", "remediation"],
  governance: ["governance", "transparency", "accountability", "eiti", "neiti", "disclosure", "corruption"],
  community: ["community", "host", "nddc", "derivation", "development", "hcdt"],
  legal: ["law", "legal", "act", "pia", "regulation", "policy", "bill"],
};

export function classifyResourceTopic(text = "") {
  const normalized = String(text).toLowerCase();

  if (!normalized.trim()) {
    return "none";
  }

  for (const [topic, keywords] of Object.entries(TOPIC_KEYWORDS)) {
    if (keywords.some((keyword) => normalized.includes(keyword))) {
      return topic;
    }
  }

  return "general";
}

export function initGA() {
  if (initialized || !GA_MEASUREMENT_ID || typeof window === "undefined") {
    return;
  }
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageview(path) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackAnalyticsEvent(name, params) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", name, {
    analytics_version: ANALYTICS_VERSION,
    ...params,
  });
}
